import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';

import { ConfigureService } from '@app/configure/services/configure.service';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'cng-continue',
	template: '',
})
export class ConfigureContinueComponent implements OnInit, OnDestroy {
	meta: any = this.configure_service.configure_data.meta;
	destroyed$: Subject<boolean> = new Subject<boolean>();

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {Router} router
	 * @param {ActivatedRoute} activated_route
	 * @param {ConfigureService} configure_service
	 */
	constructor(
		private router: Router,
		private activated_route: ActivatedRoute,
		private configure_service: ConfigureService
	) {}

	/**
	 * Lifecycle hook: Redirects user to last-loaded step.
	 */
	ngOnInit(): void {
		this.activated_route.params.pipe(takeUntil(this.destroyed$)).subscribe(() => {
			let path: string = this.configure_service.configure_data.steps[this.meta.current_step].route;
			const step_mode = this.configure_service.getStepMode();

			if (step_mode === 'part_exchange') {
				path = 'part-exchange';
			} else if (step_mode === 'reserve') {
				path = 'payment-options';
			}

			this.router.navigate(['/configure', 'e', this.meta.enquiry_hash, path]);
		});
	}

	/**
	 * Destroys component and any open subscriptions.
	 */
	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
